import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { POPUP_MENU_EVENTS } from '@/values/general.values';

@Component({
  name: 'ed-nav-submenu'
})
export default class EdNavSubmenuComponent extends Vue {

  @Prop() readonly submenuClass: string;
  @Prop() readonly buttonClass: string;
  @Prop() readonly loading: boolean;
  @Prop() readonly menu: any;

  openMenu(menu) {
    this.$emit('clicked', menu); 
  }

  closeMenu() {
    this.$edEventBus.$emit(POPUP_MENU_EVENTS.CLOSE_POPUP_MENU);
  }

  get hasDeepSubmenu() {
    return this.menu.submenu.some((item: any) => item.submenu && item.submenu.length > 0);
  }
  
}